<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <template #buttonSlot>
          <el-form-item>
            <el-button type="primary" icon="el-icon-download" :loading="exportLoading" @click="exportTerminals">导出</el-button>
          </el-form-item>
        </template>
      </toolbar>

      <!--列表：主次层级 + 键值对齐，每列最多两行。最后修改：2026-08-07 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" @row-click="handleRowClick"
        ref="table" class="custom-tbl cplate-table" height="100%" style="width: 100%">
        <el-table-column type="selection" width="48" align="center"> </el-table-column>

        <el-table-column label="终端" min-width="140">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main" :title="scope.row.TerminalName">{{ scope.row.TerminalName || '-' }}</div>
              <div class="cell-meta" :title="scope.row.TerminalId">{{ scope.row.TerminalId || '-' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="归属" min-width="150">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main" :title="formatDepartmentName(scope.row)">{{ formatDepartmentName(scope.row) || '-' }}</div>
              <div class="cell-meta">{{ scope.row.CampusName || scope.row.campusName || '未设校区' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="位置" min-width="140">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main" :title="scope.row.AuthDeptName || scope.row.authDeptName">{{ scope.row.AuthDeptName || scope.row.authDeptName || '未授权班级' }}</div>
              <div class="cell-meta" :title="scope.row.Remarks || scope.row.remarks">{{ scope.row.Remarks || scope.row.remarks || '未填安装位置' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="96" align="center">
          <template slot-scope="scope">
            <div class="cell-block cell-block--center">
              <el-tag size="mini" class="status-tag" :type="scope.row.IsOnLine == 1 ? 'success' : 'info'" disable-transitions>
                {{ scope.row.IsOnLine == 1 ? '在线' : '离线' }}
              </el-tag>
              <el-tag size="mini" class="status-tag" :type="hasPhoneTerminal(scope.row) ? 'success' : 'info'">
                {{ hasPhoneTerminal(scope.row) ? '已开话机' : '未开话机' }}
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="能力" width="148" align="center">
          <template slot-scope="scope">
            <div class="cell-block cell-block--center">
              <div class="tag-row">
                <el-tag size="mini" :type="scope.row.IsPush ? 'success' : 'info'">{{ scope.row.IsPush ? '推送' : '不推送' }}</el-tag>
                <el-tag size="mini" :type="scope.row.IsAuthMEGVII ? 'success' : 'info'">{{ scope.row.IsAuthMEGVII ? '人脸开' : '人脸关' }}</el-tag>
              </div>
              <div class="cell-meta">{{ licenseTypeLabel(scope.row) || '未设授权' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="其它" min-width="160">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main">{{ scope.row.CreateTime || scope.row.createTime || '-' }}</div>
              <div class="cell-meta" :title="otherMetaText(scope.row)">{{ otherMetaText(scope.row) }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="96" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              class="op-link op-link--phone"
              :disabled="hasPhoneTerminal(scope.row)"
              @click.stop="handleEnablePhoneForRow(scope.row)">
              {{ hasPhoneTerminal(scope.row) ? '已开通' : '开通话机' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page"
          :page-size="PageSize"
          :total="total"
          style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">

          <el-form-item label="终端标识" prop="TerminalId">
            <el-input v-model="editForm.TerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="校区" prop="CampusId">
            <el-select v-model="editForm.CampusId" placeholder="请选择校区（可不选）" clearable filterable style="width: 100%">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="String(item.Id)" />
            </el-select>
          </el-form-item>

          <!-- 添加管理员权限判断 -->
          <el-form-item v-if="isBlogAdmin" label="是否进行人脸授权" prop="IsAuthMEGVII">
            <el-switch v-model="editForm.IsAuthMEGVII" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>

          <el-form-item v-if="isBlogAdmin" label="授权方式" prop="LicenseType">
            <el-select v-model="editForm.LicenseType" placeholder="请选择授权方式" style="width: 100%">
              <el-option v-for="item in LicenseTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="editForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>
          <el-form-item label="安装位置">
            <el-input type="textarea" v-model="editForm.Remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="终端标识" prop="TerminalId">
            <el-input v-model="addForm.TerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="校区" prop="CampusId">
            <el-select v-model="addForm.CampusId" placeholder="请选择校区（可不选）" clearable filterable style="width: 100%">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="String(item.Id)" />
            </el-select>
          </el-form-item>

          <!-- 添加管理员权限判断 -->
          <el-form-item v-if="isBlogAdmin" label="是否进行人脸授权" prop="IsAuthMEGVII">
            <el-switch v-model="addForm.IsAuthMEGVII" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>

          <el-form-item v-if="isBlogAdmin" label="授权方式" prop="LicenseType">
            <el-select v-model="addForm.LicenseType" placeholder="请选择授权方式" style="width: 100%">
              <el-option v-for="item in LicenseTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="addForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>

          <el-form-item label="安装位置">
            <el-input type="textarea" v-model="addForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 指令下发模态框 -->
      <el-dialog title="下发指令" :visible.sync="commandDialogVisible" width="30%">
        <el-form :model="commandForm" label-width="80px">
          <el-form-item label="选择指令" prop="commandType">
            <el-select v-model="commandForm.commandType" placeholder="请选择指令">
              <el-option label="关机" value="shutdown"></el-option>
              <el-option label="重启" value="reboot"></el-option>
              <el-option label="更新H5" value="updateH5"></el-option>
              <el-option label="更新资源" value="resourceNotification"></el-option>
              <el-option label="更新人员" value="userChangeNotification"></el-option>
              <el-option label="增量更新人员" value="userAddNotification"></el-option>
              <el-option label="清除定时开关机" value="clearPowerOnOffTime"></el-option>
              <el-option v-if="isBlogAdmin" label="更新APK"
                value="updateApk"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="commandDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitCommand">确认下发</el-button>
        </div>
      </el-dialog>

      <!-- 导入班牌：选择文件 -->
      <el-dialog :visible.sync="importDialogVisible" width="860px" custom-class="person-import-dialog"
        :close-on-click-modal="false" append-to-body @closed="onImportDialogClosed">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-monitor"></i></span>
          <div>
            <strong>批量导入班牌终端</strong>
            <p>归属当前顶部学校；填写终端标识、终端名称，可选填安装位置与设备说明，默认不推送、不授权</p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>下载模板</strong><em>按列填写终端标识、名称、安装位置与设备说明</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" @click="downloadImportTemplate">
            <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
            <span class="pi-template-card__meta">
              <strong>班牌终端批量导入模板.xlsx</strong>
              <em>含终端标识、终端名称、安装位置、设备说明四列；后两列可选</em>
            </span>
            <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
          </button>
          <el-upload :key="'cplate-upload-' + importUploadKey" ref="importUpload"
            class="pi-upload" drag action="#" :auto-upload="false" :limit="1" :show-file-list="false"
            accept=".xlsx,.xls" :on-change="onImportFileChange" :on-remove="onImportFileRemove"
            :on-exceed="onImportExceed">
            <div v-if="importFileRaw" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div>
                <strong>{{ importFileRaw.name }}</strong>
                <em>已选择，点击「解析并预览」进入核对</em>
              </div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击选择或拖拽 Excel 到此处</strong>
              <em>仅支持标准 .xlsx / .xls 文件</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="importDialogVisible = false">关闭</el-button>
          <el-button type="primary" icon="el-icon-view" :disabled="!importFileRaw"
            :loading="importParsing" @click="parseImportFile">
            解析并预览
          </el-button>
        </div>
      </el-dialog>

      <!-- 班牌导入核对 -->
      <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="720px"
        custom-class="person-import-dialog" append-to-body
        :before-close="(done) => { this.backToImportSelect(); done(); }">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>班牌导入核对</strong>
            <p>共 {{ outputs.length }} 条{{ importPreviewKeyword ? `，筛选 ${filteredOutputs.length} 条` : '' }}，确认无误后写入当前学校</p>
          </div>
        </div>
        <div class="toolbar-filter-bar toolbar-filter-bar--embed">
          <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
            <div class="toolbar-filter-fields">
              <el-form-item>
                <el-input v-model="importPreviewKeyword" clearable prefix-icon="el-icon-search"
                  placeholder="终端标识 / 名称 / 安装位置" class="toolbar-field-w-xl" />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <el-table :data="pagedOutputs" ref="outputs_table" class="pi-preview-table" border stripe
          style="width: 100%" max-height="440">
          <el-table-column type="index" label="#" width="50" align="center" :index="importPreviewIndex" />
          <el-table-column prop="TerminalId" label="终端标识" min-width="140" show-overflow-tooltip />
          <el-table-column prop="TerminalName" label="终端名称" min-width="140" show-overflow-tooltip />
          <el-table-column prop="Remarks" label="安装位置" min-width="120" show-overflow-tooltip />
          <el-table-column prop="TerminalDesc" label="设备说明" min-width="120" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pi-preview-pager">
          <el-pagination
            small
            local-paging
            layout="total, prev, pager, next"
            :page-size="importPreviewPageSize"
            :current-page.sync="importPreviewPage"
            :total="filteredOutputs.length">
          </el-pagination>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToImportSelect">返回上一步</el-button>
          <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">
            确认导入
          </el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getCplateTerminalListPage, deleteCplateTerminal, batchDeleteCplateTerminal, editCplateTerminal, addCplateTerminal, authCplateTerminal, enableCplatePhone, enableCplatePhoneBatch, importCplateTerminalBatch, exportCplateTerminals } from '../../api/modules/attendance';
import { getSchoolDepartmentTree } from '../../api/modules/department';
import { getCampusList, batchDeviceCmd } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import { read, utils, writeFile } from 'xlsx'
import '../../style/person-import-dialog.css'
import superAdminMixin from '../../mixins/superAdminMixin'
import { getUnifiedPageSize } from '../../utils/elPaginationUnify'
import { resolveActiveSchoolId, normalizeDeptId } from '../../utils/deptCascaderProps'

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
          placeholder: '终端名称'
        },
        {
          label: '序列号',
          key: 'terminalId',
          placeholder: '终端标识/序列号'
        },
        {
          label: '状态',
          key: 'isOnLine',
          type: 'select',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '在线', value: '1' },
            { label: '离线', value: '0' }
          ]
        },
      ],
      users: [],
      roles: [],
      campusOptions: [],
      total: 0,
      buttonList: [],
      page: 1,
      /** 与全站统一分页一致，避免 UI 写死 10 而请求被拦截器注入更大 pageSize 导致后页无数据。最后更新：2026-09-03 */
      PageSize: getUnifiedPageSize(),
      listLoading: false,
      exportLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        TerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],

        // 新增编辑验证规则
        IsAuthMEGVII: [
          { required: true, message: '请选择是否进行授权旷世', trigger: 'change' }
        ],
        LicenseType: [
          { required: true, message: '请选择授权方式', trigger: 'change' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        TerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        DepartmentId: 0,
        TerminalTypeId: "3",
        // 新增字段
        IsAuthMEGVII: false,
        LicenseType: '', // 新增
        Remarks: "", // 新增
        IsPush: false, // 新增
        CampusId: null,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        TerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],

        // 新增验证规则
        IsAuthMEGVII: [
          { required: true, message: '请选择是否进行授权旷世', trigger: 'change' }
        ],
        LicenseType: [
          { required: true, message: '请选择授权方式', trigger: 'change' }
        ],
      },
      //新增界面数据
      addForm: {
        TerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        DepartmentId: 0,
        TerminalTypeId: "3",
        // 新增字段
        IsAuthMEGVII: false,
        LicenseType: 'FACEPASS_AUTH_MCVSAFE', // 新增
        Remarks: "", // 新增
        IsPush: false, // 新增
        CampusId: null,
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      multipleSelection: [],
      LicenseTypeOptions: [
        { label: '一柒', value: 'FACEPASS_AUTH_ALGOMALL' },
        { label: '班牌厂家', value: 'FACEPASS_AUTH_MCVSAFE' },
        // { label: '亿创合', value: 'FACEPASS_AUTH_ALGOMALL' }
      ],
      // 指令下发相关数据
      commandDialogVisible: false,
      commandForm: {
        commandType: ''
      },
      currentUser: null, // 添加当前用户信息
      importDialogVisible: false,
      importFileRaw: null,
      importParsing: false,
      importUploadKey: 0,
      importKeepFileOnClose: false,
      outputs: [],
      excelShow: false,
      importPreviewKeyword: '',
      importPreviewPage: 1,
      importPreviewPageSize: 10,
    };
  },
  computed: {
    /** 顶部学校下拉的学校 Id。创建于 2026-08-11 */
    currentSchoolId() {
      return resolveActiveSchoolId(this) || ''
    },
    /** 核对列表按标识/名称/安装位置筛选。创建于 2026-08-11，最后修改：2026-08-20 */
    filteredOutputs() {
      const kw = (this.importPreviewKeyword || '').trim().toLowerCase()
      if (!kw) return this.outputs
      return this.outputs.filter((row) => {
        const id = String(row.TerminalId || '').toLowerCase()
        const name = String(row.TerminalName || '').toLowerCase()
        const remarks = String(row.Remarks || '').toLowerCase()
        const desc = String(row.TerminalDesc || '').toLowerCase()
        return id.indexOf(kw) !== -1 || name.indexOf(kw) !== -1
          || remarks.indexOf(kw) !== -1 || desc.indexOf(kw) !== -1
      })
    },
    /** 核对列表当前页。创建于 2026-08-11 */
    pagedOutputs() {
      const start = (this.importPreviewPage - 1) * this.importPreviewPageSize
      return this.filteredOutputs.slice(start, start + this.importPreviewPageSize)
    },
  },
  watch: {
    importPreviewKeyword() {
      this.importPreviewPage = 1
    },
    filteredOutputs(val) {
      const maxPage = Math.max(1, Math.ceil((val && val.length ? val.length : 0) / this.importPreviewPageSize))
      if (this.importPreviewPage > maxPage) this.importPreviewPage = maxPage
    },
  },
  methods: {

    //下发指令
    command() {
      // 检查是否选择了终端
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要操作的终端');
        return;
      }
      this.commandDialogVisible = true;
    },

    // 提交指令
    async submitCommand() {
      if (!this.commandForm.commandType) {
        this.$message.warning('请选择指令类型');
        return;
      }

      // 获取选中终端ID
      const terminalIds = this.multipleSelection.map(item => item.TerminalId);

      if (terminalIds.length === 0) {
        this.$message.warning('请选择至少一个终端');
        return;
      }

      var terminalId = terminalIds.join(',');

      this.submitLoading = true;
      try {

        var para = {
          serialNumbers: terminalId,
          commandType: this.commandForm.commandType
        }

        batchDeviceCmd(para).then((res) => {

          if (res.data.success) {
            this.$message.success(`成功下发${this.getCommandLabel(this.commandForm.commandType)}指令到${terminalIds.length}个终端`);
            this.commandDialogVisible = false;
          } else {
            // 将\n替换为<br>并启用HTML解析
            this.$message({
              message: `${res.data.msg ? res.data.msg.replace(/\n/g, '<br>') : '未知错误'}`,
              type: 'error',
              dangerouslyUseHTMLString: true
            });
          }
        });
      } catch (error) {
        this.$message.error(`接口调用失败: ${error.message}`);
      } finally {
        this.submitLoading = false;
      }
    },

    /** 向选中班牌下发旷视人脸授权配置。创建于 2025-08-18 */
    async CplateAuth() {
      try {
        await this.$confirm('确定要为选中班牌下发人脸授权吗？', '人脸授权', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 获取选中终端ID
        const terminalIds = this.multipleSelection.map(item => item.TerminalId);

        if (terminalIds.length === 0) {
          this.$message.warning('请选择至少一个终端');
          return;
        }

        var terminalId = terminalIds.join(',');

        this.submitLoading = true;

        var para = {
          serialNumbers: terminalId,
          commandType: this.commandForm.commandType
        }

        authCplateTerminal(para).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.commandDialogVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } catch (error) {
        // 用户取消授权操作
        if (error !== 'cancel') {
          this.$message.error(`接口调用失败: ${error.message}`);
        } else {
          this.$message({ type: 'info', message: '已取消人脸授权' });
        }
        return;
      } finally {
        this.submitLoading = false;
      }
    },

    // 获取指令显示名称
    getCommandLabel(type) {
      const labels = {
        'shutdown': '关机',
        'reboot': '重启',
        'updateH5': '更新H5',
        'resourceNotification': '更新资源',
        'userChangeNotification': '更新人员',
        'userAddNotification': '增量更新人员',
        'clearPowerOnOffTime': '清除定时开关机数据'
      };
      return labels[type] || type;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /** 点击行切换勾选（与勾选列行为一致） */
    handleRowClick(row, column, event) {
      if (column && column.type === 'selection') return
      if (event && event.target && typeof event.target.closest === 'function') {
        if (event.target.closest('.el-checkbox')) return
        if (event.target.closest('.op-link')) return
      }
      const isSelected = this.multipleSelection.some((item) => item.Id === row.Id)
      this.$refs.table.toggleRowSelection(row, !isSelected)
    },

    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      this.loadCampusOptions(this.DepartmentId);
      let para = {
        id: this.DepartmentId,
      };
    },

    /**
     * 拉取校区下拉（与 DutyStaff.loadCampusOptions 一致，接口 Campus/GetList）
     */
    loadCampusOptions(deptId) {
      const schoolOrDept = deptId || this.DepartmentId || 0;
      if (schoolOrDept && schoolOrDept !== 0) {
        return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolOrDept }).then((res) => {
          if (res.data.success) {
            this.campusOptions = res.data.response.data || [];
          }
        });
      }
      return getSchoolDepartmentTree({ pid: 0, type: 1 }).then((res) => {
        if (res.data.success && res.data.response) {
          return this.loadCampusOptions(res.data.response.value);
        }
      });
    },



    /** 未选校区用 null 展示；提交给接口时转为 0（与后端 long 默认一致） */
    normalizeCampusIdForApi(val) {
      if (val == null || val === '' || val === 0 || val === '0') return 0;
      const n = Number(val);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },

    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    hasPhoneTerminal(row) {
      if (!row) return false
      if (row.HasPhoneTerminal === true || row.hasPhoneTerminal === true) return true
      const pid = row.PhoneTerminalId != null ? row.PhoneTerminalId : row.phoneTerminalId
      return pid != null && Number(pid) > 0
    },

    /** 部门展示：路径过长时只保留末两级。创建于 2026-08-07 */
    formatDepartmentName(row) {
      const raw = (row && (row.DepartmentName || row.departmentName)) || ''
      if (!raw) return ''
      const parts = raw.split('/')
      if (parts.length > 2) return parts.slice(-2).join('/')
      return raw
    },

    /** 授权方式短文案。创建于 2026-08-07 */
    licenseTypeLabel(row) {
      const t = row && (row.LicenseType != null ? row.LicenseType : row.licenseType)
      if (t === 'FACEPASS_AUTH_MCVSAFE') return '班牌厂家'
      if (t === 'FACEPASS_AUTH_ALGOMALL') return '一柒'
      return ''
    },

    /** 其它列次行：版本 · 备注。创建于 2026-08-07 */
    otherMetaText(row) {
      const ver = (row && (row.Version || row.version)) || '-'
      const desc = (row && (row.TerminalDesc || row.terminalDesc)) || '-'
      return `版本 ${ver} · 备注 ${desc}`
    },

    /** 班牌开通话机（行内）。创建于 2026-08-07 */
    handleEnablePhoneForRow(row) {
      if (!row) {
        this.$message.warning('请选择班牌终端')
        return
      }
      if (this.hasPhoneTerminal(row)) {
        this.$message.warning('该班牌已开通话机')
        return
      }
      const cplateId = row.Id != null ? row.Id : row.id
      this.$confirm('确认为该班牌开通话机能力？将生成关联话机终端（同 SN）。', '开通话机', { type: 'info' })
        .then(() => {
          this.listLoading = true
          return enableCplatePhone({ cplateTerminalId: cplateId }).then((res) => {
            this.listLoading = false
            if (res.data.success) {
              this.$message.success(res.data.msg || '开通话机成功')
              this.handleQuery()
            } else {
              this.$message.error(res.data.msg || '开通失败')
            }
          })
        })
        .catch(() => {
          this.listLoading = false
        })
    },

    /** 批量为选中的班牌终端开通话机。创建于 2026-08-19 */
    async handleEnablePhone() {
      const rows = this.multipleSelection || []
      const pendingRows = rows.filter((row) => !this.hasPhoneTerminal(row))
      if (!pendingRows.length) {
        this.$message.warning('请选择未开通话机的班牌终端')
        return
      }
      try {
        await this.$confirm(`确认批量为 ${pendingRows.length} 台班牌开通话机？`, '批量开通话机', {
          type: 'info',
          confirmButtonText: '确认开通',
          cancelButtonText: '取消'
        })
        this.listLoading = true
        const res = await enableCplatePhoneBatch({
          cplateTerminalIds: pendingRows.map((row) => row.Id != null ? row.Id : row.id)
        })
        if (res.data.success) {
          this.$message.success(res.data.msg || '批量开通成功')
          this.handleQuery()
        } else {
          this.$message.error(res.data.msg || '批量开通失败')
        }
      } catch (error) {
        if (error !== 'cancel') this.$message.error('批量开通失败')
      } finally {
        this.listLoading = false
      }
    },

    async exportTerminals() {
      const params = {
        departmentId: this.DepartmentId,
        name: this.filters.name || '',
        terminalId: this.filters.terminalId || ''
      }
      try {
        const response = await exportCplateTerminals(params)
        if (!response.data || response.data.size === 0) {
          this.$message.warning('暂无可导出的班牌终端')
          return
        }
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `班牌终端_${new Date().getTime()}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (error) {
        this.$message.error('导出失败')
      }
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    /** 切换每页条数。最后更新：2026-09-03 */
    handleSizeChange(val) {
      this.PageSize = val;
      this.page = 1;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        ...this.filters,
        page: this.page,
        intPageSize: this.PageSize,
        departmentId: this.DepartmentId,
      }
      this.listLoading = true;

      //testapi();
      //NProgress.start();
      getCplateTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    /** 删除选中班牌（支持批量，单次最多 10 条）。最后更新：2026-09-12 */
    handleDel() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '请选择要删除的数据！',
          type: 'error',
        })
        return
      }
      if (rows.length > 10) {
        this.$message({
          message: '单次最多删除 10 条，请按页勾选后分批删除',
          type: 'error',
        })
        return
      }

      const tip = rows.length === 1
        ? '确认删除该记录吗?'
        : `确认批量删除选中的 ${rows.length} 台班牌终端吗?`

      this.$confirm(tip, "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          const ids = rows.map(r => r.Id).filter(id => id != null && id !== '')
          const req = ids.length === 1
            ? deleteCplateTerminal({ id: ids[0] })
            : batchDeleteCplateTerminal({ ids: ids.join(',') })
          req.then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg || "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }

      var row = rows[0];
      const savedCampusId = normalizeDeptId(row.CampusId) || null;

      this.options = [];

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      const schoolId = row.DepartmentId || this.DepartmentId;
      this.editForm.DepartmentId = schoolId;
      this.editForm.CampusId = savedCampusId;
      this.loadCampusOptions(schoolId).then(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.editForm.CampusId = savedCampusId;
          }, 0);
        });
      });
    },
    //显示新增界面
    handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        TerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "1",
        TerminalDesc: "",
        DepartmentId: this.DepartmentId, // 直接使用当前页面统一选中的学校ID
        TerminalTypeId: "3",
        // 新增字段
        IsAuthMEGVII: false,
        LicenseType: 'FACEPASS_AUTH_MCVSAFE', // 新增
        Remarks: "", // 新增
        IsPush: false,
        CampusId: null,
      };
      this.loadCampusOptions(this.DepartmentId);
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.CampusId = this.normalizeCampusIdForApi(para.CampusId);

            editCplateTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.CampusId = this.normalizeCampusIdForApi(para.CampusId);

            addCplateTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    // 格式化部门名称：只保留路径 of 最后两级
    formatDepartmentNameCol(row, column, cellValue) {
      if (!cellValue) return '';
      const parts = cellValue.split('/');
      if (parts.length > 2) {
        return parts.slice(-2).join('/');
      }
      return cellValue;
    },

    /** 打开批量导入弹窗。创建于 2026-08-11 */
    ImportCensus() {
      if (!this.currentSchoolId) {
        this.$message.warning('请先在顶部选择学校后再导入');
        return;
      }
      this.resetImportDialog();
      this.importDialogVisible = true;
    },
    resetImportDialog() {
      this.importFileRaw = null;
      this.importParsing = false;
      this.importUploadKey += 1;
      this.importPreviewKeyword = '';
      this.importPreviewPage = 1;
    },
    /** 核对表序号（跨页连续）。创建于 2026-08-11 */
    importPreviewIndex(index) {
      return (this.importPreviewPage - 1) * this.importPreviewPageSize + index + 1;
    },
    onImportDialogClosed() {
      if (this.importKeepFileOnClose) {
        this.importKeepFileOnClose = false;
        return;
      }
      this.resetImportDialog();
    },
    backToImportSelect() {
      this.excelShow = false;
      this.importDialogVisible = true;
    },
    onImportFileChange(file) {
      this.importFileRaw = file && file.raw ? file.raw : null;
    },
    onImportFileRemove() {
      this.importFileRaw = null;
    },
    onImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.importUploadKey += 1;
      this.$nextTick(() => {
        this.importFileRaw = nextFile;
      });
    },
    /** 下载班牌终端导入模板。创建于 2026-08-11，最后修改：2026-08-20 */
    downloadImportTemplate() {
      const headers = ['终端标识', '终端名称', '安装位置', '设备说明'];
      const sample = ['SN001', '一年级1班班牌', '教学楼1层101室', '门口左侧'];
      const sheet = utils.aoa_to_sheet([headers, sample]);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, '班牌导入');
      writeFile(book, '班牌终端批量导入模板.xlsx');
    },
    parseImportFile() {
      if (!this.importFileRaw) {
        this.$message.warning('请先选择 Excel 文件');
        return;
      }
      const file = this.importFileRaw;
      if (!/\.(xls|xlsx)$/.test(String(file.name || '').toLowerCase())) {
        this.$message.error('上传格式不正确，请上传xls或者xlsx格式');
        return;
      }
      this.importParsing = true;
      const loading = this.$loading({ lock: true, text: '正在读取文件', background: 'rgba(0,0,0,0.7)' });
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = read(data, { type: 'binary' });
          const wsname = workbook.SheetNames[0];
          const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
          this.outputs = this.reSetKey(ws);
          this.importPreviewKeyword = '';
          this.importPreviewPage = 1;
          loading.close();
          this.importParsing = false;
          if (!this.outputs.length) {
            this.$message.warning('未解析到有效数据，请确认表头包含「终端标识」「终端名称」');
            return;
          }
          this.importKeepFileOnClose = true;
          this.importDialogVisible = false;
          this.$nextTick(() => {
            this.excelShow = true;
          });
        } catch (e) {
          loading.close();
          this.importParsing = false;
          this.$message.error('文件读取失败');
        }
      };
      fileReader.onerror = () => {
        loading.close();
        this.importParsing = false;
        this.$message.error('文件读取失败');
      };
      fileReader.readAsBinaryString(file);
    },
    reSetKey(ws) {
      const temp = [];
      (ws || []).forEach((item) => {
        const terminalId = String(item['终端标识'] || item['TerminalId'] || '').trim();
        const terminalName = String(item['终端名称'] || item['TerminalName'] || '').trim();
        const remarks = String(item['安装位置'] || item['Remarks'] || '').trim();
        const terminalDesc = String(item['设备说明'] || item['TerminalDesc'] || '').trim();
        if (!terminalId && !terminalName) return;
        temp.push({
          TerminalId: terminalId,
          TerminalName: terminalName,
          Remarks: remarks,
          TerminalDesc: terminalDesc,
        });
      });
      return temp;
    },
    removeImport(e) {
      const row = e && e.row;
      const name = (row && (row.TerminalName || row.TerminalId)) || '该终端';
      this.$confirm('确定要删除「' + name + '」吗？').then(() => {
        const idx = this.outputs.indexOf(row);
        if (idx >= 0) this.outputs.splice(idx, 1);
      });
    },
    /** 确认写入当前顶部学校。创建于 2026-08-11 */
    SavaImport() {
      if (!this.currentSchoolId) {
        this.$message.warning('请先在顶部选择学校后再导入');
        return;
      }
      if (!this.outputs.length) {
        this.$message.warning('没有要导入的数据');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '导入中',
        background: 'rgba(0,0,0,0.7)'
      });
      importCplateTerminalBatch({
        DepartmentId: this.currentSchoolId,
        Rows: this.outputs,
      }).then((res) => {
        loading.close();
        if (res.data && res.data.success) {
          this.$message({ message: res.data.msg || '导入完成', type: 'success', duration: 0, showClose: true });
          this.excelShow = false;
          this.handleQuery();
        } else {
          this.$message({ message: (res.data && res.data.msg) || '导入失败', type: 'error', duration: 0, showClose: true });
        }
      }).catch(() => {
        loading.close();
        this.$message({ message: '导入失败', type: 'error', duration: 0, showClose: true });
      });
    },
  },
  mounted() {
    // 初始化当前用户信息
    if (window.localStorage.user) {
      this.currentUser = JSON.parse(window.localStorage.user);
    }
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let buttons = getButtonList(this.$route.path, routers);
    // 非超级管理员（admin / blogadmin）隐藏人脸授权按钮
    if (!this.isBlogAdmin) {
      this.buttonList = buttons.filter(btn => btn.Func !== 'CplateAuth');
    } else {
      this.buttonList = buttons;
    }
    // 权限库名称为「授权下发」，与班级授权易混淆，前端展示改为「人脸授权」
    this.buttonList = this.buttonList.map((btn) => (
      btn.Func === 'CplateAuth' ? { ...btn, name: '人脸授权' } : btn
    ));
    if (!this.buttonList.some(item => item.Func === 'ImportCensus' || item.name === '导入')) {
      this.buttonList.push({ name: '导入', Func: 'ImportCensus', id: 991, IsHide: false, icon: 'el-icon-upload2', btnType: 'success' });
    }
    if (!this.buttonList.some(item => item.Func === 'handleEnablePhone' || item.name === '批量开通话机')) {
      this.buttonList.push({ name: '批量开通话机', Func: 'handleEnablePhone', id: 992, IsHide: false, icon: 'el-icon-phone-outline', btnType: 'primary' });
    }
  },
};
</script>

<style scoped>
/* 列表单元：主次两行、垂直居中对齐。最后修改：2026-08-07 */
.cell-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-height: 44px;
  padding: 2px 0;
}
.cell-block--center {
  align-items: center;
}
.cell-main {
  color: #303133;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-meta {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tag-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.status-tag {
  min-width: 64px;
  text-align: center;
}
.cplate-table >>> .op-link.el-button--text {
  padding: 4px 10px;
  margin: 0;
  border: none !important;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--btn-primary, #2563eb);
  background: transparent;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.cplate-table >>> .op-link.el-button--text:hover,
.cplate-table >>> .op-link.el-button--text:focus {
  color: var(--btn-primary-hover, #1d4ed8);
  background: rgba(37, 99, 235, 0.08);
  border: none !important;
  box-shadow: none;
  transform: none;
}
.cplate-table >>> .op-link.el-button--text.is-disabled,
.cplate-table >>> .op-link.el-button--text.is-disabled:hover,
.cplate-table >>> .op-link.el-button--text.is-disabled:focus {
  color: #c0c4cc;
  background: transparent;
  cursor: not-allowed;
}

/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.cplate-table >>> .el-table__body tr {
  cursor: pointer;
}

.cplate-table >>> .el-table td,
.cplate-table >>> .el-table th {
  vertical-align: middle;
}

.cplate-table >>> .el-table .cell {
  line-height: 20px;
  padding-left: 12px;
  padding-right: 12px;
}

.cplate-table >>> .el-tag--mini {
  height: 22px;
  line-height: 20px;
  padding: 0 8px;
}
.pi-preview-pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
